<template>
  <div id="app">
    <keep-alive>
      <router-view :key="key" />
    </keep-alive>
  </div>
</template>

<script>
import { AppMixin } from '../common'

export default {
  name: 'App',
  mixins: [AppMixin],
  components: {},
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {}
}
</script>

<style lang="less">
@import '../../less/styles.less';
</style>

<style>
body {
  margin: 0;
  padding: 0;
  font-size: 16px;
}
</style>
<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
  font-family: PingFangSC-Regular,PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
